import { fetchRequest, postRequest, patchRequest } from 'services/api.service';

export async function fetchScriptResponse(leadId: string) {
  return fetchRequest(`/script-responses/by-lead/${leadId}`);
}

export async function updateScriptResponse(scriptResponseId: string, payload = {}) {
  return patchRequest(`/script-responses/${scriptResponseId}`, payload);
}

export async function continueAutomation(leadId: string) {
  return postRequest(`/leads/${leadId}/automated-follow-ups`);
}
